<template>
  <b-card style="padding:40px;">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>

    <h5><b>DELIVERY ORDER (SUBMITTED)</b></h5>
    <hr />
    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-name`">Full Name</label>
          <b-form-input
            v-model="form.name"
            :id="`input-name`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-date`">Date</label>
          <b-form-input
            v-model="form.date"
            :id="`input-date`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-companyName`">Company Name</label>
          <b-form-input
            v-model="form.company"
            :id="`input-companyName`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-roles`">Roles</label>
          <b-form-input
            v-model="form.role"
            :id="`input-roles`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <TableDeliveryOrderView
      :fields="fields"
      :items="items"
      :cat="this.$route.query.cat"
      :id="this.$route.query.id"
    />
    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickBack">
          BACK </b-button
        >&nbsp;&nbsp;&nbsp;
        <b-button variant="primary" size="sm" @click="downloadInv">
          DOWNLOAD DO </b-button
        >&nbsp;&nbsp;&nbsp;
        <b-button variant="primary" size="sm" @click="downloadDOReport">
          DOWNLOAD DO REPORT
        </b-button>
        &nbsp;&nbsp;&nbsp;
        <b-button
          variant="primary"
          size="sm"
          v-if="accLvl != '1'"
          @click="onClickChange"
          >EDIT </b-button
        >&nbsp;&nbsp;&nbsp;
        <b-button
          variant="danger"
          size="sm"
          v-if="accLvl != '1'"
          @click="onClickDeleteDO"
          >DELETE
        </b-button>
      </b-col>
    </b-row>

    <b-modal id="delete-do" title="Delete Confirmation">
      <p>
        <b>Are you sure you want to delete ?</b>
      </p>

      <template v-slot:modal-footer="{ close }">
        <b-button variant="primary" size="sm" @click="close()">
          CLOSE
        </b-button>
        <b-button variant="danger" size="sm" @click="onClickDeleteDOConfirm">
          Delete
        </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import TableDeliveryOrderView from "@/table/user/deliveryOrder/TableDeliveryOrderView";
import moment from "moment";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {
      items: [],
      form: {
        name: "",
        date: "",
        company: "",
        role: "",
        type: ""
      },

      // Loading
      isLoading: false,
      fullPage: true,

      fields: [
        {
          label: "No",
          key: "no",
          sortable: false
        },
        {
          label: "Product Name",
          key: "name",
          sortable: true
        },
        {
          label: "Quantity",
          key: "qty",
          sortable: true
        },
        {
          label: "Quantity Type",
          key: "qtyType",
          sortable: true
        }
      ],

      accLvl: null
    };
  },
  created() {
    this.showDO();
    this.form.type = this.$route.query.pro_cat;
    this.accLvl = this.$store.getters.getAccessLevel;
  },
  methods: {
    showDO() {
      this.$store.dispatch("showDO", this.$route.query.id).then(res => {
        if (res.data.response.code === 100) {
          this.form.id = this.$route.query.id;
          this.form.name = res.data.data.userdetails.name;
          this.form.date = moment(res.data.data.date).format("DD/MM/YYYY");
          this.form.company = res.data.data.userdetails.company;
          this.form.role = res.data.data.userdetails.role_details.desc;
          res.data.data.pro_stock.forEach(element => {
            this.items.push({
              name: element.product.name,
              sku: element.product_id,
              qty: element.quantity,
              qtyType: element.quantity_type === 1 ? "Pcs" : "Ctn"
            });
          });
        }
      });
    },

    // Download Invoice
    downloadInv() {
      this.isLoading = true;
      this.$store
        .dispatch("getInvoice", {
          category: this.$route.query.cat,
          stock_id: this.$route.query.id
        })
        .then(res => {
          if (res.data.response.code === 100) {
            this.isLoading = false;
            window.open(
              `${process.env.VUE_APP_BASE_URL}/${res.data.data.path}`,
              "_blank"
            );
            // window.open(`https://azizazri.com/${res.data.data.path}`, "_blank");
          } else {
            this.isLoading = false;
          }
        });
    },

    // Download PO Report
    downloadDOReport() {
      this.isLoading = true;
      this.$store
        .dispatch("getDOReport", {
          any_id: this.$route.query.id
        })
        .then(res => {
          if (res.data.response.code === 100) {
            this.isLoading = false;
            window.open(
              `${process.env.VUE_APP_BASE_URL}/${res.data.data.path}.xlsx`,
              "_blank"
            );
            // window.open(`https://azizazri.com/${res.data.data.path}`, "_blank");
          } else {
            this.isLoading = false;
          }
        });
    },
    onClickBack() {
      if (parseInt(this.accLvl) === 1) {
        let path = "";
        if (this.$route.query.type === "sub") {
          path = `home_dealer_admin?state=${this.$route.query.state}&stockist_id=${this.$route.query.upline}&tab=4&page=${this.$route.query.page}&filter=${this.$route.query.filter}&date=${this.$route.query.date}&name=${this.$route.query.name}&outlet_name=${this.$route.query.outlet_name}&email=${this.$route.query.email}`;
        } else {
          path = `/delivery_order?filter=${this.$route.query.filter}&page=${this.$route.query.page}&name=${this.$route.query.name}&date=${this.$route.query.date}`;
        }

        this.$router.push({
          path: path
        });
      } else {
        if (
          this.$route.query.from !== undefined &&
          this.$route.query.from === "created"
        ) {
          this.$router.push({
            path: `delivery_order_user`
          });
        } else {
          if (this.$route.query.filter !== undefined) {
            this.$router.push({
              path: `delivery_order_user?page=${this.$route.query.page}&filter=${this.$route.query.filter}&date=${this.$route.query.date}`
            });
          } else {
            this.$router.go(-1);
          }
        }
      }
    },

    onClickChange() {
      this.$router.push({
        path: `createdo?id=${this.$route.query.id}&cat=4&type=update`
      });
    },
    onClickDeleteDO() {
      this.$bvModal.show("delete-do");
    },
    onClickDeleteDOConfirm() {
      this.$store.dispatch("deleteDO", this.form.id).then(res => {
        if (res.data.response.code === 1) {
          this.$bvModal.hide("delete-do");
          this.onClickBack();
        }
      });
    }
  },
  components: {
    TableDeliveryOrderView,
    Loading
  }
};
</script>
<style lang="css" scoped></style>
